import { createAsyncAction } from 'typesafe-actions';

import { CauseEntity, LocationEntity, ReiEntity, SequelaEntity } from '@portal/common/types';

export const getLocationsAsync = createAsyncAction(
    'GET_LOCATIONS_REQUEST',
    'GET_LOCATIONS_SUCCESS',
    'GET_LOCATIONS_FAILURE'
)<undefined, LocationEntity[], string>();

export const getCausesAsync = createAsyncAction(
    'GET_CAUSES_REQUEST',
    'GET_CAUSES_SUCCESS',
    'GET_CAUSES_FAILURE'
)<undefined, CauseEntity[], string>();

export const getSequelasAsync = createAsyncAction(
    'GET_SEQUELAS_REQUEST',
    'GET_SEQUELAS_SUCCESS',
    'GET_SEQUELAS_FAILURE'
)<undefined, SequelaEntity[], string>();

export const getRisksAsync = createAsyncAction(
    'GET_RISKS_REQUEST',
    'GET_RISKS_SUCCESS',
    'GET_RISKS_FAILURE'
)<undefined, ReiEntity[], string>();

export const getEtiologiesAsync = createAsyncAction(
    'GET_ETIOLOGIES_REQUEST',
    'GET_ETIOLOGIES_SUCCESS',
    'GET_ETIOLOGIES_FAILURE'
)<undefined, ReiEntity[], string>();

export const getImpairmentsAsync = createAsyncAction(
    'GET_IMPAIRMENTS_REQUEST',
    'GET_IMPAIRMENTS_SUCCESS',
    'GET_IMPAIRMENTS_FAILURE'
)<undefined, ReiEntity[], string>();

export const getInjuryAsync = createAsyncAction(
    'GET_INJURY_REQUEST',
    'GET_INJURY_SUCCESS',
    'GET_INJURY_FAILURE'
)<undefined, ReiEntity[], string>();
